import React from "react";
import * as ReactBootstrap from "react-bootstrap";
import PropTypes from "prop-types";

// import "./InputFormControlComponent.css";


const InputFormControl = ({ onChange, value, placeholder, name }) => {

  return (
    <div className="form-control-wrapper">

      <ReactBootstrap.Form.Control
        className="form-control-custom"
        type="text"
        placeholder={placeholder}
        name={name}
        onChange={(e) => onChange(name,e)}
        value={value || ""}
        autoComplete="off"
      />

    </div>
  );
}


InputFormControl.propTypes = {
  placeholder: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  value: PropTypes.string,
};


InputFormControl.defaultProps = {
  value: ""
};


export default InputFormControl;